import React from 'react';

import { Card, CardBody } from 'reactstrap';
import { color } from '~/assets/styles/colors';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '../Text';
import { Container, DivMontante, TextMontante, ImgMontante } from './styles';
import { symbolPriceFormatter } from '../../helpers/price';
import money from '../../assets/img/money.svg';

export function Montante({ data }) {
	return (
		<Container>
			<Text style={{ textAlign: 'left', marginBottom: '4px' }}>
				Montante de Crédito
			</Text>

			<Card
				style={{
					marginBottom: 0,
					backgroundColor: color.secondary,
					borderRadius: '0px 8px 8px 8px',
				}}>
				<CardBody className="py-4 px-2">
					<DivMontante>
						{data.montante === undefined || data.montante === null ? (
							<LoaderMini />
						) : (
							<>
								<TextMontante
									style={{ marginRight: '5%' }}>
									<Text
										color="softBlack"
										size="big">
										{data && data.montante === '--' ? data.montante : symbolPriceFormatter(data.montante)}
									</Text>
								</TextMontante>

								<ImgMontante
									alt="money"
									width="20"
									src={money}
								/>
							</>
						)}
					</DivMontante>
				</CardBody>
			</Card>
		</Container>
	);
}

